import { useIntercomFinAIAgentWidget } from './useIntercomFinAIAgentWidget'

const IntercomFinAIAgent = () => {
  useIntercomFinAIAgentWidget()
  return null
}

export default IntercomFinAIAgent
